import {Pipe, PipeTransform} from "@angular/core";
import {BzTagTone} from "@bringoz/ui";
import {THREE_PL_STATUS_TONE} from "../constants/threepl.constant";

@Pipe({
  standalone: false,
  name: "threeplStatusTone",
})
export class ThreeplStatusTonePipe implements PipeTransform {
  transform(status: string): BzTagTone {
    return THREE_PL_STATUS_TONE[status] || "neutral";
  }
}
